import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gift",
  "use": "gift-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"gift\"><path d=\"M2.441 12.23H10.8V22H2.44v-9.77zm10.734 0h8.358V22h-8.358v-9.77zM1 6.514h9.825v4.608H1V6.514zm12.175 0H23v4.608h-9.825V6.514zm2.83-.732l3.871-2.547-3.39-.045-.054-2.813L12 4.985 7.247 0l-.053 2.725-3.284.044 4.592 3.013h7.503z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol